export enum DataDeliveryType {
    NotSelected = 0,
    Survey = 1,
    ImplementedEMR = 2,
    PlannedEMR = 3,
    UnsuportedEMR = 4
}
